import "./MyDataTable.css";
import Collection from "../../Model/Collection";
import Navette from "../../Model/Navette";
import AdditionnalMetadata from "../../Model/AdditionnalMetadata";
import MyDataTable from "./MyDataTable";
import Loc from "../../../Loc/Loc";

interface ExpandedDataTableProps {
    collection: Collection;
}

export default function ExpandedDataTable(props: ExpandedDataTableProps) {
    const customStyles = {
        rows: {
            style: {
                background: "#ececec"
            },
        }
    };

    return (
        <div className="documents">
            {
                props.collection.navCategories.length > 0 ?
                    <div className="datatableNavettes"><MyDataTable title={Loc.trad().ExpandedDataTableTitle + props.collection.reference + " " + total_recep(props.collection.navettes)}
                        categories={props.collection.navCategories}
                        data={define_navettes_data(props.collection.navettes)}
                        filter={""}
                        expandable={false}
                        pagination={false}
                        selectable={false}
                        background={"#c6c6c5"}
                        element={"Navettes"}
                        collection={props.collection}
                        customStyles={customStyles}></MyDataTable></div> :
                    <div style={{ background: "#c6c6c5", paddingLeft: "10px" }}>{Loc.trad().ExpandedDataTableNoDocument}</div>
            }
        </div>
    )
}

export function total_recep(navettes: Navette[]) {
    let nbr_recep: number = 0;
    navettes.forEach((nav) => {
        if (nav.retourClient !== "") {
            nbr_recep++;
        }
    })
    return ("(" + nbr_recep + "/" + navettes.length + ")");
}

export function define_navettes_data(navettes: Navette[]) {
    if (navettes.length === 0) {
        return [];
    }
    var data: any[] = navettes.map((nav: Navette) => {
        let map = new Map<string, string>();
        let addMetas: AdditionnalMetadata[] = nav.concerneDoc.additionnalMetas;
        map.set('id', nav.id.toString()); // info fixe navette
        map.set('retourClient', nav.retourClient); // info fixe navette
        map.set('dateRetour', nav.dateRetour); // info fixe navette
        map.set('retourClientPar', nav.retourClientPar); // info fixe navette
        map.set('commentaireRetour', nav.commentaireRetour); // info fixe navette
        map.set('version', nav.concerneDoc.version.toString()); // info fixe concerneDoc
        map.set('name', nav.concerneDoc.name); // info fixe concerneDoc
        map.set('index', nav.index.toString()); // info fixe pratique
        addMetas.forEach((data) => {
            map.set(data.name, data.value); // additionnalMetas
        })
        const result = Object.fromEntries(map);
        return result;
    })
    return data;
}